import { render, staticRenderFns } from "./LogoutScreen.vue?vue&type=template&id=29fdfae5&scoped=true"
import script from "./LogoutScreen.vue?vue&type=script&lang=js"
export * from "./LogoutScreen.vue?vue&type=script&lang=js"
import style0 from "./LogoutScreen.vue?vue&type=style&index=0&id=29fdfae5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29fdfae5",
  null
  
)

export default component.exports